// extracted by mini-css-extract-plugin
export default {"LanguageModalWrapper":"LanguageSelector_LanguageModalWrapper__vn8xF"};